module.exports = __webpack_public_path__ + "static/media/Coffee_at_home_credit_Getty_Images_desktop.c5f35531.jpg";